/* eslint-disable */
import { emptyLink } from './helpers/empty-link';
import { debounce } from './helpers/debounce';
import { handleFirstTab } from './helpers/focus-handler';
import { scrollTo } from './helpers/scroll-to';
import { clickEnterListener } from './helpers/enter-listener';
import { toggleBodyOverflow } from './helpers/toggle-body-overflow';
import { getCookie, getCookies, setCookie, setCookies, deleteCookie, deleteCookies } from './helpers/cookie';
import {
    getLocalStorageItem,
    getLocalStorageItems,
    setLocalStorageItem,
    setLocalStorageItems,
    deleteLocalStorageItem,
    deleteLocalStorageItems,
} from './helpers/local-storage';
import {
    getParameter,
    getParameters,
    setParameter,
    setParameters,
    deleteParameter,
    deleteParameters,
    getUpdatedUrl,
    updateHistory,
    clearUrl,
} from './helpers/url';
import { addInViewportClass } from './helpers/addInViewportClass';
import { isVisible } from './helpers/is-visible';
import { getFocusableElements } from './helpers/get-focusable-elements';
import { trapFocusHandler } from './helpers/trap-focus-handler';
import swiperHelpers from './helpers/swiper-helpers';

const allowedReadyFunctions = ['emptyLink', 'scrollTo'];

const Gravity = {
    readyAutoMethods: {
        emptyLink: true,
        scrollTo: true,
    },
    handleFirstTab,
    emptyLink,
    scrollTo,
    /**
     * @param callbackFunc - Callback function that will be triggered when document will be ready
     */
    ready(callbackFunc) {
        const readyFunction = () => {
            for (const [functionName, value] of Object.entries(this.readyAutoMethods)) {
                if (allowedReadyFunctions.includes(functionName) && value) {
                    this[functionName]();
                }
            }

            callbackFunc();
        };

        if (document.readyState !== 'loading') {
            // Document is already ready, call the callback directly
            readyFunction();
        } else if (document.addEventListener) {
            // All modern browsers to register DOMContentLoaded
            document.addEventListener('DOMContentLoaded', readyFunction);
        } else {
            // Old IE browsers
            document.attachEvent('onreadystatechange', () => {
                if (document.readyState === 'complete') {
                    readyFunction();
                }
            });
        }
    },

    debounce,
    getCookie,
    getCookies,
    setCookie,
    setCookies,
    deleteCookie,
    deleteCookies,
    getLocalStorageItem,
    getLocalStorageItems,
    setLocalStorageItem,
    setLocalStorageItems,
    deleteLocalStorageItem,
    deleteLocalStorageItems,
    getUpdatedUrl,
    updateHistory,
    getParameter,
    getParameters,
    setParameters,
    setParameter,
    deleteParameters,
    deleteParameter,
    clearUrl,
    addInViewportClass,
    isVisible,
    getFocusableElements,
    trapFocusHandler,
    clickEnterListener,
    toggleBodyOverflow,
    swiper: swiperHelpers,
};

export default Gravity;
/* eslint-enable */
